module.exports = __webpack_public_path__ + "static/media/foreground--bottom.f1ed9a60.svg";